import { Tabs, type TabItem } from '@/components/layout/Tabs';

const CHANNEL_TABS: TabItem[] = [
  { id: 'web', label: 'Web' },
  { id: 'whatsapp', label: 'WhatsApp' },
  { id: 'voice', label: 'Voice' },
  { id: 'test', label: 'Test' },
];

const INBOX_TABS: TabItem[] = [
  { id: 'conversations', label: 'Conversations' },
  { id: 'leads', label: 'Leads' },
];

const SIMULATOR_TABS: TabItem[] = [
  { id: 'whatsapp', label: 'WhatsApp' },
  { id: 'voice', label: 'Voice' },
  { id: 'voice-realtime', label: 'Voice Live' },
];

export interface SubNavTabsProps {
  activeId: string;
  onChange: (id: string) => void;
  tabs?: TabItem[];
  'aria-label'?: string;
}

export function SubNavTabs({
  activeId,
  onChange,
  tabs = CHANNEL_TABS,
  'aria-label': ariaLabel = 'Channel type',
}: SubNavTabsProps) {
  return (
    <Tabs
      tabs={tabs}
      activeId={activeId}
      onChange={onChange}
      variant="pills"
      aria-label={ariaLabel}
    />
  );
}

const CRM_TABS: TabItem[] = [
  { id: 'follow-ups', label: 'Follow-ups' },
  { id: 'appointments', label: 'Appointments' },
  { id: 'leads', label: 'Leads' },
  { id: 'deals', label: 'Deals' },
  { id: 'contacts', label: 'Contacts' },
  { id: 'templates', label: 'Templates' },
];

const INSIGHTS_TABS: TabItem[] = [
  { id: 'bot-health', label: 'Bot Health' },
  { id: 'activity', label: 'Activity' },
  { id: 'analytics', label: 'Analytics' },
];

const SETTINGS_TABS: TabItem[] = [
  { id: 'profile', label: 'Business Profile' },
  { id: 'ai-rag', label: 'AI & RAG' },
  { id: 'notifications', label: 'Notifications' },
  { id: 'api-keys', label: 'API Keys' },
  { id: 'account', label: 'Account' },
];

export { CHANNEL_TABS, SIMULATOR_TABS, INBOX_TABS, CRM_TABS, INSIGHTS_TABS, SETTINGS_TABS };
